/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Get_4Inputs */

const en_cp_lead_get_4 = /** @type {(inputs: Cp_Lead_Get_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National lead group + monthly office hours with the Bystep team and practitioners`)
};

const id_cp_lead_get_4 = /** @type {(inputs: Cp_Lead_Get_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grup lead nasional + office hours bulanan dengan tim Bystep dan praktisi`)
};

/**
* | output |
* | --- |
* | "National lead group + monthly office hours with the Bystep team and practitioners" |
*
* @param {Cp_Lead_Get_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_get_4 = /** @type {((inputs?: Cp_Lead_Get_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Get_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_get_4(inputs)
	return en_cp_lead_get_4(inputs)
});